<template>
  <div>
    <v-app-bar
      v-scroll="checkScroll"
      app
      color="white"
      tag="header"
      data-testid="main-topBar"
      :elevation="elevation"
      :height="$vuetify.breakpoint.smAndDown ? 110 : 64"
    >
      <v-row>
        <v-col
          md="6"
          sm="12"
          class="d-flex align-center"
          :class="{
            'pl-6': !$vuetify.breakpoint.smAndDown,
            'pl-0': $vuetify.breakpoint.smAndDown,
          }"
        >
          <v-app-bar-nav-icon
            class="hidden-lg-and-up mr-2"
            @click="$emit('toggleNavBar')"
          ></v-app-bar-nav-icon>

          <div class="explore-bar">
            <ExploreSearchBar
              @openFinding="handleOpenFindingDrawer"
              @openTask="handleOpenTask"
            />
          </div>
        </v-col>

        <v-col md="6" sm="12" class="d-flex justify-end align-center">
          <v-btn
            v-if="aiFeaturesAreEnabled"
            data-testid="topBar-help-center"
            elevation="0"
            large
            rel="noopener"
            rounded
            target="_blank"
            text
            :href="$constants.urls.helpCenter"
          >
            <v-icon left color="blue-grey darken-3" size="24"
              >mdi-help-circle-outline</v-icon
            >

            <span class="caption blue-grey--text text--darken-2">{{
              $t('menu.header.help')
            }}</span>
          </v-btn>

          <ReportsDrawerTrigger
            v-if="userIsCoachOrAdmin"
            @showReportsDrawer="handleOpenReportsDrawer"
          />

          <SettingsMenu />

          <LanguageSelector />

          <NotificationsMenu @showReportsDrawer="handleOpenReportsDrawer" />

          <MainMenu />
        </v-col>
      </v-row>
    </v-app-bar>
    <FindingDrawer
      v-if="isFindingDrawerOpen"
      hide-overlay
      :visible="isFindingDrawerOpen"
      :findingId="selectedFindingId"
      @close="handleFindingDrawerClose"
      @deleted="handleFindingDrawerClose"
    />
    <ReportsDrawer
      v-if="isReportsDrawerOpen"
      :visible="isReportsDrawerOpen"
      :organizationId="organizationId"
      :reportId="reportId"
      @close="isReportsDrawerOpen = false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import mixin from '@/mixins/mixin.vue'
import trackerMixin from '@/mixins/tracking/trackerMixin.vue'

import SettingsMenu from './SettingsMenu.vue'
import ReportsDrawerTrigger from './ReportsDrawerTrigger.vue'
import LanguageSelector from './LanguageSelector.vue'
import NotificationsMenu from './NotificationsMenu.vue'
import MainMenu from './MainMenu.vue'

import ExploreSearchBar from '@/containers/Explore/ExploreSearchBar.vue'
import FindingDrawer from '@/components/FindingDrawer/FindingDrawer.vue'
import ReportsDrawer from '@/components/ReportsDrawer/ReportsDrawer.vue'

import access from '@/lib/access.js'
import eventHub, { HUB_EVENTS } from '@/lib/event-hub'

const SCROLL_THRESHOLD = 45

export default {
  name: 'TopBar',

  mixins: [mixin, trackerMixin],

  components: {
    SettingsMenu,
    ReportsDrawerTrigger,
    NotificationsMenu,
    LanguageSelector,
    MainMenu,
    ExploreSearchBar,
    FindingDrawer,
    ReportsDrawer,
  },

  data() {
    return {
      scrollY: window.scrollY,
      isFindingDrawerOpen: false,
      selectedFindingId: '',
      isReportsDrawerOpen: false,
      reportId: null,
    }
  },

  computed: {
    ...mapGetters(['account', 'organizationId', 'organization']),

    elevation() {
      return this.$vuetify.breakpoint.mobile || this.scrollY > SCROLL_THRESHOLD
        ? 2
        : 0
    },

    aiFeaturesAreEnabled() {
      return access.aiFeaturesAreEnabled(this.account, this.organization)
    },
  },

  methods: {
    handleOpenReportsDrawer(reportId) {
      this.reportId = reportId
      this.isReportsDrawerOpen = true
      this.trackOpenReportList({ source: 'topBar' })
    },

    checkScroll() {
      this.scrollY = window.scrollY
    },
    handleOpenFindingDrawer(findingId) {
      this.selectedFindingId = findingId
      this.isFindingDrawerOpen = true
    },

    handleOpenTask(taskId) {
      eventHub.$emit(HUB_EVENTS.TASK_EDITION_DRAWER.UPDATE, taskId)
    },

    handleFindingDrawerClose() {
      this.isFindingDrawerOpen = false
      this.selectedFindingId = null
    },

    userIsCoachOrAdmin() {
      return access.isLeadershipOrCoach(this.account)
    },
  },
}
</script>
<style lang="scss" scoped>
.explore-bar {
  width: inherit;
}
</style>
